<div class="flex flex-col h-full">
    <div class="grid grid-cols-1 lg:grid-cols-1 items-start gap-8 flex-1 overflow-y-auto px-20">
        @if(!_orderWizardService.loading$()) {
            <ng-container [ngTemplateOutlet]="component_loaded"></ng-container>
        }
        @else {
            <ng-container [ngTemplateOutlet]="component_loading"></ng-container>
        }
    </div>
</div>

<ng-template #component_loading>
    <corp-loading></corp-loading>
</ng-template>

<ng-template #component_loaded>
    <order-purchase-summary></order-purchase-summary>
    <pickup-point-card-summary></pickup-point-card-summary>
    <itsme-customer-summary></itsme-customer-summary>
</ng-template>